import React, { useState, useRef } from 'react';

import { Vector2 } from './ImageAnnotations.classes';
import {
  loadImage,
  draw,
  getAnnotationAtPosition,
  handleMouseMove,
  handleClick,
} from './ImageAnnotation.utils';
import HoverBubble from './HoverBubble/HoverBubble';
import styled from 'styled-components';

const ImageAnnotation = ({ imageAsset, annotations, imageId }) => {
  const canvasEl = useRef(null);
  const [ctx, setCtx] = useState(null);
  const [imageCtx, setImageCtx] = useState(null);
  const [mousePosition, setMousePosition] = useState(new Vector2(0, 0));
  const [hoveredAnnotation, setHoveredAnnotation] = useState({});

  // Once the canvas ref is ready and present, set the canvas context
  React.useEffect(() => {
    if (!ctx && canvasEl && canvasEl.current) {
      const canvasContext = canvasEl.current.getContext('2d');
      if (canvasContext) {
        setCtx(canvasContext);
      }
    }
  }, [canvasEl]);

  const imageUrl = imageAsset + '?w=644&auto=compress,format&fit=crop&ar=1:1.5';

  // Once the canvas context is ready, load the image into the canvas
  React.useEffect(() => {
    if (ctx) {
      loadImage(imageUrl || '', ctx, setImageCtx);

      // Add an event listener on resize to reload the image
      window.addEventListener('resize', () => {
        loadImage(imageUrl || '', ctx, setImageCtx);
      });
    }
  }, [ctx, imageUrl]);

  // Upon change of critical data, trigger a re-draw of the canvas
  React.useEffect(() => {
    draw(ctx, imageCtx, annotations, hoveredAnnotation);
  }, [ctx, imageCtx, annotations, hoveredAnnotation]);

  // If mouse position is updated set the hovered annotation
  React.useEffect(() => {
    setHoveredAnnotation(
      getAnnotationAtPosition(annotations, mousePosition, ctx)
    );
  }, [mousePosition]);

  return (
    <Container id={`image-annotation-${imageId}`}>
      <canvas
        onMouseMove={handleMouseMove(ctx, setMousePosition)}
        onClick={handleClick(ctx, annotations, hoveredAnnotation, setHoveredAnnotation)}
        ref={canvasEl}
        style={{
          width: '100%',
          height: '100%'
        }}
      />
      <HoverBubble imageId={imageId} annotation={hoveredAnnotation || {}} ctx={ctx} />
    </Container>
  );
};

const Container = styled.div`
  position: relative;
`;

export default ImageAnnotation;
